import { computed } from "vue";
import { useStore } from "vuex";
import { Flags, hasFeatureFlag } from "@/classes/FeatureFlags";

export function assignedScopeChoices(items = [], ids = [], allowAll = false) {
    if (allowAll) return items;
    const assigned = new Set(ids || []);
    return items.filter((item) => assigned.has(item.id));
}

// Derive controls from the same hydrated lists and assignments used by their
// options. Stored "multiple_*" strings are historical hints, not live state.
export function useScopeChoices() {
    const store = useStore();
    const operator = computed(
        () =>
            Boolean(import.meta.env.VITE_ADMIN_ID) &&
            store.getters.userID() === import.meta.env.VITE_ADMIN_ID
    );
    const locationChoices = computed(() =>
        assignedScopeChoices(
            store.state.locationList || [],
            store.state.user?.location_ids,
            operator.value ||
                (store.state.user?.role === "admin" && !store.state.user?.location_ids?.length)
        )
    );
    const departmentChoices = computed(() =>
        hasFeatureFlag(Flags.DepartmentsModule)
            ? assignedScopeChoices(
                  store.state.departmentList || [],
                  store.state.user?.department_ids,
                  operator.value
              )
            : []
    );
    return {
        locationChoices,
        departmentChoices,
        multipleLocations: computed(() => locationChoices.value.length > 1),
        multipleDepartments: computed(() => departmentChoices.value.length > 1)
    };
}
